import React from 'react';
import { FiCalendar, FiPhone, FiMail } from 'react-icons/fi';
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaTwitter,
} from 'react-icons/fa';

import Icon from '../Icon';

import * as styles from './ContactBar.module.scss';

function ContactBar({ data, setIsCalendlyModalOpen }) {
  const contactData = data || {};
  const contactLinks = contactData?.contact_links ?? [];
  const socialLinks = contactData?.social_links ?? [];

  const iconsMap = {
    calendly: FiCalendar,
    phone: FiPhone,
    email: FiMail,
    linkedin: FaLinkedinIn,
    facebook: FaFacebookF,
    youtube: FaYoutube,
    twitter: FaTwitter,
  };

  return (
    <nav
      className={styles.contactbar}
      aria-label="Liens de contact et réseaux sociaux"
    >
      <div className={styles.contactbarContainer}>
        {/* Contacts */}
        <div className={styles.contactbarContacts} aria-label="Contacts">
          {contactLinks.map((contact, index) => {
            const id = contact?.contact_link_id;
            const title = contact?.contact_link_title;

            if (!id || !title) return null;

            if (id === 'calendly') {
              return (
                <button
                  type="button"
                  className={styles.contactbarContactsButton}
                  key={`${id}-${index}`}
                  onClick={() => setIsCalendlyModalOpen?.(true)}
                  aria-haspopup="dialog"
                >
                  <Icon
                    className={styles.contactbarIcon}
                    name={id}
                    iconsMap={iconsMap}
                    aria-hidden="true"
                    focusable="false"
                  />
                  <span
                    className={`${styles.srOnly} ${styles.contactbarLabel}`}
                  >
                    {title}
                  </span>
                </button>
              );
            }

            const href = id === 'phone' ? `tel:${title}` : `mailto:${title}`;

            return (
              <a
                className={styles.contactbarContactsLink}
                href={href}
                key={`${id}-${index}`}
              >
                <Icon
                  className={styles.contactbarIcon}
                  name={id}
                  iconsMap={iconsMap}
                  aria-hidden="true"
                  focusable="false"
                />
                <span className={`${styles.srOnly} ${styles.contactbarLabel}`}>
                  {title}
                </span>
              </a>
            );
          })}
        </div>

        {/* Socials */}
        <div className={styles.contactbarSocials} aria-label="Réseaux sociaux">
          <span className={`${styles.srOnly} ${styles.contactbarSocialsTitle}`}>
            {contactData?.socials_title}
          </span>

          {socialLinks.map((social, index) => {
            const id = social?.social_link_id;
            const url = social?.social_link?.url;

            if (!id || !url) return null;

            return (
              <a
                className={styles.contactbarSocialLink}
                href={url}
                key={`${id}-${index}`}
                aria-label={`Suivre Monstock sur ${id}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                <Icon
                  className={styles.contactbarSocialIcon}
                  name={id}
                  iconsMap={iconsMap}
                  aria-hidden="true"
                  focusable="false"
                />
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
}

export default ContactBar;
